import { instance } from "../apiBase/instance";
import { BlockchainType } from "../type";

export const getChainById = async (id: number) : Promise<BlockchainType> => {
    const response = await instance.get(`api/chains/${id}`);
    return response.data.data;
}